import { FormikField } from '@ahmdigital/ui';
import { lowerCase, map, toLower } from 'lodash/fp';
import { useFormikContext } from 'formik';
import React from 'react';

import { ProductType } from '../../../../../../types/product';
import constants from '../../../../../../ahm-constants';
import getScaleOptions from '../../../../../../utils/get-scale-options';

const defaultScaleOptions = getScaleOptions({ endText: 'cover', format: toLower });

const mapScaleToIncomeType = (scale: string) => {
  if (scale === constants.SCALE.SINGLE) {
    return constants.INCOME_TYPE.SINGLE;
  }

  return constants.INCOME_TYPE.COUPLE;
};

type ScaleFieldProps = {
  label?: string;
  product?: ProductType;
};

const ScaleField = ({ label = 'I’m after', product }: ScaleFieldProps) => {
  const { setFieldValue } = useFormikContext();
  const selectable = product?.scales?.selectable;
  const scaleOptions = selectable
    ? map((value) => ({ text: `${lowerCase(value)} cover`, value }), selectable)
    : defaultScaleOptions;

  return (
    <FormikField
      // @ts-expect-error - Automatic, Please fix when editing this file
      onChange={({ target: { value } }) => {
        setFieldValue('incomeType', mapScaleToIncomeType(value as string));
        setFieldValue('scale', value);
      }}
      inputVariant={['button', 'fullWidth']}
      label={label}
      name="scale"
      options={scaleOptions}
      size="auto"
      type="dropdown"
    />
  );
};

export default ScaleField;
